import React from "react";
import { Container, Group, Text } from "@mantine/core";

import UseStyles from "./useStyles";

export default function FooterPage() {
  const { classes } = UseStyles();

  return (
    <div className={classes.footer}>
      <Container size="lg" className={classes.inner}>
        <Group position="apart" style={{ width: "100%" }}>
          <Group>
            <Text
              variant="link"
              component="a"
              href={process.env.REACT_APP_TERMS_AND_CONDITIONS}
              className={classes.text}
            >
              Terms and Conditions
            </Text>
            <Text
              variant="link"
              component="a"
              href={process.env.REACT_APP_SITE_MAP}
              className={classes.text}
            >
              Site Map
            </Text>
            <Text
              variant="link"
              component="a"
              href={process.env.REACT_APP_CONTACT_US}
              className={classes.text}
            >
              Contact us
            </Text>
          </Group>
          <Text className={classes.copyright}>
            © 2022 Safra National Bank of New York. All rights reserved.
          </Text>
        </Group>
      </Container>
    </div>
  );
}
